export default __webpack_public_path__ + "static/media/icon-human-resources.d779f9d9.svg";